import { emulatorScreen, mobileScreen } from "../../utils/styleUtils";

const styles = (theme) => ({
  quizScreenContainer: {
    height: "100vh",
    backgroundColor: "#ecf2f1",
  },

  questionImg: {
    width: "150px",
    height: "150px",
    position: "absolute",
    zIndex: "5",
  },

  includedTitle: {
    color: "#003e4c",
    fontSize: "46px",
    fontWeight: "500",
    fontFamily: "Oswald",
  },

  serviceTitle: {
    color: "#003e4c",
    fontSize: "20px",
    fontWeight: "500",
    fontFamily: "Oswald",
    marginBottom: "4px",
  },

  serviceDesc: {
    color: "#003e4c",
    fontSize: "15px",
    fontWeight: "400",
    fontFamily: "Rubik",
    maxWidth: "350px",
    lineHeight: "1.2",
  },

  dropImageStyle: {
    width: "400px",
    height: "100px",
  },

  draggableDrop: {
    border: "3px solid #003e4c",
    borderRadius: "6px",
    backgroundColor: "#fff",
    width: "410px",
  },

  answerTitleIcon: {
    width: "90px",
    height: "40px",
    marginRight: "1.5rem",
  },

  answerTitleContainer: {
    backgroundColor: "#003e4c",
    padding: "0.7rem 1rem",
  },

  answerTitleText: {
    color: "#fff",
    fontSize: "25px",
    fontWeight: "500",
    fontFamily: "Oswald",
  },

  answerDescContainer: {
    padding: "0 1rem 1rem 1rem",
    height: "210px",
  },

  droppableCircle: {
    width: "70px",
    height: "70px",
    borderRadius: "50%",
    marginTop: "1rem",
    border: "3px dashed #003e4c",
  },

  droppableAnswer: {
    width: "79px",
    height: "79px",
    borderRadius: "50%",
    marginTop: "1rem",
  },

  submitButton: {
    backgroundColor: "#00b1d9",
    color: "#fff",
    fontSize: "30px",
    fontWeight: "500",
    padding: "0px 20px",
    borderRadius: "5px",
    fontFamily: "'Oswald', sans-serif",
    "&:hover": {
      backgroundColor: "#056f8a",
    },
    [mobileScreen(theme)]: {
      fontSize: "18px",
      padding: "0px 10px",
    },
  },

  evaluatorModalContainer: {
    width: "350px",
    padding: "2rem 3rem",
    backgroundColor: "#fff",
    borderRadius: "6px",
    [mobileScreen(theme)]: {
      padding: "1rem 2rem",
      width: "240px"
    },
  },

  evaluatorModalContainerMCQ: {
    width: "50%",
    padding: "2rem 3rem",
    backgroundColor: "#fff",
    borderRadius: "6px",
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [mobileScreen(theme)]: {
      padding: "1rem 2rem",
      width: "60%",
      // width: "240px"
    },
  },

  evalDesc: {
    margin: "24px 0",
    color: "#003e4c",
    fontFamily: "Rubik",
    [mobileScreen(theme)]: {
      margin: "12px 0",
      fontSize: '0.7rem'
    },
  },

  correctIncorrectIcon: {
    width: "200px",
    height: "45px",
    [mobileScreen(theme)]: {
      width: "120px",
      height: "30px",
    },
  },

  modalCalculation: {
    padding: '32px',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    width: '100%',
    maxWidth: '900px',
    [mobileScreen(theme)]: {
      padding: '12px',
      paddingTop: 0,
      gap: '8px',
    },
  },
  calculationTitle: {
    fontSize: '32px',
    fontWeight: '500',
    marginBottom: '24px',
    textAlign: 'center',
    color: "#003e4c",
    fontFamily: "Rubik",
    [mobileScreen(theme)]: {
      fontSize: '20px',
      marginBottom: '12px',
    },
  },
  calculationContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    width: '100%',
    justifyContent: 'center',
  },
  fraction: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    flex: 1,
    maxWidth: '600px',
    [mobileScreen(theme)]: {
      maxWidth: '400px',
    },
  },
  numerator: {
    fontSize: '28px',
    color: "#003e4c",
    fontFamily: "Rubik",
    textAlign: 'center',
    padding: '8px',
    width: '100%',
    [mobileScreen(theme)]: {
      fontSize: '16px',
    },
  },
  divider: {
    width: '100%',
    height: '2px',
    backgroundColor: '#4A4A4A',
    margin: '8px 0',
    [mobileScreen(theme)]: {
      margin: '2px 0',
    },
  },
  denominator: {
    fontSize: '20px',
    color: "#003e4c",
    fontFamily: "Rubik",
    textAlign: 'center',
    padding: '8px',
    width: '70%',
    [mobileScreen(theme)]: {
      fontSize: '12px',
    },
  },
  operator: {
    fontSize: '28px',
     color: "#003e4c",
    fontFamily: "Rubik",
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
    height: '100%',
    padding: '0 16px',
    marginTop: '-24px',
    [mobileScreen(theme)]: {
      padding: '0 4px',
      fontSize: '20px',
      marginTop: '-10px',
    },
  },
  percentage: {
    fontSize: '28px',
     color: "#003e4c",
    fontFamily: "Rubik",
    alignSelf: 'center',
    marginTop: '-24px',
    [mobileScreen(theme)]: {
      fontSize: '20px',
      marginTop: '-10px',
    },
  },
  equals: {
    fontSize: '28px',
     color: "#003e4c",
    fontFamily: "Rubik",
    alignSelf: 'center',
    marginTop: '-24px',
    padding: '0 16px',
    [mobileScreen(theme)]: {
      fontSize: '20px',
      marginTop: '-10px',
    },
  },
  result: {
    fontSize: '48px',
     color: "#003e4c",
    fontFamily: "Rubik",
    alignSelf: 'center',
    marginTop: '-32px',
    [mobileScreen(theme)]: {
      fontSize: '30px',
      marginTop: '-10px',
    },
  },
});

export default styles;
